/**
  @Description: 疾病覆盖
 * @Date: 2024-01-29 10:00:13
 */

import svgDiseaseCoverage1Vue from './svg-disease-coverage-1.vue';
import svgCircleDasharrayVue from './svg-circle-dasharray.vue';

export const svgDiseaseCoverage1 = svgDiseaseCoverage1Vue;
export const svgCircleDasharray = svgCircleDasharrayVue;
